<template>
    <m-ripple color="#fff" @click="$emit('click')">
        <div class="btn btn-primary">{{ text }}</div>
    </m-ripple>
</template>
<script>
const classes = {
    'success': 'color-success-bg',
    'error': 'color-error-bg',
    'primary': 'color-primary-bg'
}
export default {
    props: {
        text: String,
        type: String
    },
    methods: {
        buttonClass() {
            return classes[this.type]
        }
    }
}
</script>